import { useState, useRef, useEffect } from "react";
import { BrowserQRCodeReader } from "@zxing/browser";
import errorSound from "assets/sounds/error.mp3";

const QRScanner = ({ qrCodeResult }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const codeReader = new BrowserQRCodeReader();
        let isUnmounted = false;
        let result;

        const handleDecode = async () => {
            try {
                result = await codeReader.decodeFromVideoDevice(null, videoRef.current, (result, error) => {
                    if (result) {
                        let textCode = result?.getText();
                        if(textCode){
                            qrCodeResult(textCode)
                        }
                    }
                    if(error){
                        console.error('error',error)
                    }
                });
            } catch (error) {
                console.error("QR Scan Error:", error);
                new Audio(errorSound).play();
            }
        };

        handleDecode();

        return () => {
            isUnmounted = true;
            result?.stop()
        };
    }, []);

    return (
        <div style={{ textAlign: "center" }}>
            <h3 style={{ color: '#fff' }}>QR Code Scanner</h3>
            <video ref={videoRef} style={{ width: "100%", maxWidth: "400px" }} />
        </div>
    );
};

export default QRScanner;
